import {
  IComparablesTransactionDTO,
  PerUnitPriceModes,
  PriceModes,
  ZooplaPricePerUnitModes,
} from "react-migration/domains/comparables";
import { formatToPrecision } from "react-migration/lib";
import { MeasurementSystem } from "src/js/stores/user/store";
import { pricePerMsqToPricePerFtsq } from "src/js/util/units_and_constants";

type OverviewSearchItem = Pick<
  IComparablesTransactionDTO,
  "total_floor_area" | "est_price" | "price"
>;

export function calculateAveragePricePerUnitArea(
  search: OverviewSearchItem[],
  unitType: MeasurementSystem,
  priceMode: PriceModes
) {
  if (!search?.length) {
    return 0;
  }
  let priceField: "est_price" | "price";
  if (priceMode === ZooplaPricePerUnitModes.RENT_ASKING || priceMode === PerUnitPriceModes.PRICE) {
    priceField = "price";
  } else {
    priceField = "est_price";
  }
  const records = search.filter((record) => record.total_floor_area && record[priceField]);
  if (records.length === 0) {
    return 0;
  }
  const sumOfPrices = records.reduce((sum, record) => {
    return (record[priceField] ?? 0) + sum;
  }, 0);
  const sumOfFloorAreas = records.reduce(
    (sum, { total_floor_area }) => Number(total_floor_area) + sum,
    0
  );

  const mean = sumOfPrices / sumOfFloorAreas;
  const pricePerUnitAreaValue: number =
    unitType === MeasurementSystem.METRIC ? mean : pricePerMsqToPricePerFtsq(mean);

  return formatToPrecision(pricePerUnitAreaValue);
}
